var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),(_vm.data_api.use_timer==1)?_c('timer'):_vm._e(),_c('div',{staticClass:"form-page"},[_c('questions',{attrs:{"form":_vm.form,"currentPage":'*',"totalPage":0,"isTrivia":_vm.isTrivia,"percentage":_vm.percentage||null}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_cover"},[_c('h3')])
}]

export { render, staticRenderFns }